import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";

import "./index.css";
import { AuthProvider } from "./components/auth-provider";
import { router } from "./router";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Tax2 root element is missing");
}

createRoot(root).render(
  <StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </StrictMode>,
);
